import {APP_KEY,HTTP_URL, PHP_API_URL} from "../../../../util/constants";
import request from "../../../../util/request";
import Cookies from 'js-cookie'
//获取用户列表
export function getPointsListRequest(type,offset,limit,callback) {
    let formData = new FormData();
    formData.append("appkey",APP_KEY);
    formData.append("caozuo",'get_user_jifen_jilu');
    formData.append("type", type);
    formData.append('username',Cookies.get("username"))
    formData.append("offset", offset);
    formData.append("limit", limit);

    return fetch(HTTP_URL+'index.php/User/i',{
        method: 'post',
        body: formData,
    }).then(function (res) {
        return res.json();
    }).then(function (json) {
        callback && callback(json);
    }).catch(e => {
        console.error(e);
        callback && callback(e);

    });
}

export function getWXQrUrlRequest(dingdan_amount, dingdan_jifen, callback) {
  let formData = new FormData()
  formData.append('appkey', APP_KEY)
  formData.append('username', Cookies.get('username'));
  formData.append('dingdan_amount', dingdan_amount*100)
  // formData.append('dingdan_amount', dingdan_amount)
  formData.append('dingdan_jifen', dingdan_jifen)
  formData.append('user_login', Cookies.get('user_login'))
  return request(
    PHP_API_URL + '/weixinpay/native_v3.php',
    {
      method: 'POST',
      body: formData,
    },
    callback,
  )
}

export function checkPayResultRequest(dingdan_code, callback) {
  let formData = new FormData()
  formData.append('appkey', APP_KEY)
  formData.append('caozuo', 'check_weixinpay')
  formData.append('username', Cookies.get('username'));
  formData.append('dingdan_code', dingdan_code)
  return request(
    PHP_API_URL + '/index.php/WeixinPay/i',
    {
      method: 'POST',
      body: formData,
    },
    callback,
  )
}


export function getPayRatioListRequest(callback) {
  let formData = new FormData()
  formData.append('appkey', APP_KEY)
  formData.append('caozuo', 'get_chongzhi_duihuan_jifen_biaozhun_list')
  return request(
    PHP_API_URL + '/Chongzhi/i',
    {
      method: 'POST',
      body: formData,
    },
    callback,
  )
}



export function getAliQrUrlRequest(dingdan_amount, dingdan_jifen, callback) {
  let formData = new FormData()
  formData.append('appkey', APP_KEY)
  formData.append('username', Cookies.get('username'));
  formData.append('dingdan_amount', dingdan_amount*100)
  // formData.append('dingdan_amount', dingdan_amount)
  formData.append('dingdan_jifen', dingdan_jifen)
  formData.append('user_login', Cookies.get('user_login'))
  return request(
    PHP_API_URL + '/alipay/alipay-sdk-php-all-master/v2/bss/p.php',
    {
      method: 'POST',
      body: formData,
    },
    callback,
  )
}


export function getUserPointsRequest( callback) {
    let formData = new FormData();
    formData.append("appkey",APP_KEY);
    formData.append('caozuo',"get_user_now_jifen");
    formData.append('username', Cookies.get('username'));;

    return request(PHP_API_URL+"/index.php/User/i", {
        method: "POST",
        body: formData
    }, callback);
}
